import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function RefundPolicy() {
  const [contactEmail, setContactEmail] = useState("");
  useEffect(() => {
    api.get("/site-settings").then((r) => setContactEmail(r.data.contact_email || ""));
  }, []);

  return (
    <div className="max-w-3xl mx-auto px-6 sm:px-12 py-16 sm:py-24" data-testid="refund-policy-page">
      <div className="eyebrow mb-3">Plain talk</div>
      <h1 className="font-serif text-4xl sm:text-6xl text-brand-soft leading-[1.05]">Cancellation & refund policy.</h1>
      <p className="mt-5 text-brand-soft/75 leading-relaxed">We keep our gatherings small and intentional — when you book, a seat is held. Here&apos;s how cancellations work, in plain English.</p>

      <div className="mt-10 space-y-6">
        {[
          { t: "7+ days before", d: "Full refund. No questions asked." },
          { t: "3–7 days before", d: "50% refund (we keep the token to cover what's already been ordered for your seat)." },
          { t: "Less than 3 days / 72 hours", d: "No refund — but you can transfer your booking to a friend. Send us their details and we'll move your slot." },
          { t: "No-show", d: "No refund. We saved your seat (and your treats)." },
        ].map((row) => (
          <div key={row.t} className="grid sm:grid-cols-12 gap-3 sm:gap-6 py-5 border-b border-brand-maroon/10">
            <div className="sm:col-span-4 font-serif text-xl text-brand-maroon">{row.t}</div>
            <div className="sm:col-span-8 text-brand-soft/80 leading-relaxed">{row.d}</div>
          </div>
        ))}
      </div>

      <div className="mt-12 bg-brand-ivory rounded-2xl p-6 sm:p-8">
        <div className="font-serif text-2xl text-brand-soft">Refund timing</div>
        <p className="text-brand-soft/75 mt-2 leading-relaxed">Once approved, refunds are processed within <strong>5–7 business days</strong> to the original payment method. You&apos;ll also get a WhatsApp note when it&apos;s done.</p>
      </div>

      <div className="mt-8 text-sm text-brand-soft/60">
        Need to cancel or transfer? Reach us via our Telegram / WhatsApp channels{contactEmail ? <> or at <a href={`mailto:${contactEmail}`} className="underline text-brand-maroon">{contactEmail}</a></> : ""} with your booking reference.
      </div>
    </div>
  );
}
